import { render, staticRenderFns } from "./EditRole.vue?vue&type=template&id=416f573c&scoped=true"
import script from "./EditRole.vue?vue&type=script&lang=js"
export * from "./EditRole.vue?vue&type=script&lang=js"
import style0 from "./EditRole.vue?vue&type=style&index=0&id=416f573c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f573c",
  null
  
)

export default component.exports